module.exports = __webpack_public_path__ + "img/on-drop-image.e8a1dd72.png";